// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/poppins-v20-latin-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/dm-sans-v11-latin-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/dm-sans-v11-latin-500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/dm-sans-v11-latin-700.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/dm-sans-v11-latin-700italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/poppins-v20-latin-500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/poppins-v20-latin-700.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/poppins-v20-latin-900.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
    background-color: #11172e!important;
    color:#0f1721;
}
body::-webkit-scrollbar{
    display: none;
}
.eye_password{
    position: absolute;
    top:11px;
    right: 6px;
    color:white;
    cursor: pointer;
}
.step_instruction{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 18px;
    margin-bottom: 10px;
    color: white;
    line-height: 1.5;
    text-align: center;
}
.highlight_instruction{
    color: greenyellow;
    font-weight: bold;
}
.button_manual_right{
    background-color: #58638980;
    padding: 5px;
    border-radius: 5px;
    cursor: pointer;
    color:#96a0af;
    -webkit-user-select: none;
            user-select: none;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}
.fadeAnimationMain{
    animation: fadeIn 0.5s ease-in-out;
}
@keyframes fadeIn {
    from {
        opacity: 0.3; /* Начальная прозрачность: 0 (невидимый) */
    }
    to {
        opacity: 1; /* Конечная прозрачность: 1 (полностью видимый) */
    }
}
.rule {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    padding: 20px;
    color: white;
    font-size: 18px;
    
    font-family: Popins, sans-serif;
    background: linear-gradient(315deg, rgb(22 22 22 / 50%) 0%, rgb(43 43 43 / 66%) 100%);
    border-radius: 10px;
    border: 1px solid #ffffff1a;
}
:where(.css-dev-only-do-not-override-3rel02).ant-card-bordered .ant-card-cover {
    margin-top: 0!important;
    margin-inline-start: 0!important;
    margin-inline-end: 0!important;
}
button{
    border: none;
    cursor: pointer;
}
.containerSuccsesMessages{
    position: fixed;
    top:90px;

    left: 50%; /* Разместить по горизонтали в середине */
    transform: translate(-50%, -50%); /* Сдвигаем обратно на половину размеров элемента */
    z-index: 1000000;
}
/* poppins-regular - latin */
@font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* dm-sans-regular - latin */
@font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* dm-sans-500 - latin */
@font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* dm-sans-700 - latin */
@font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* dm-sans-700italic - latin */
@font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'DM Sans';
    font-style: italic;
    font-weight: 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* poppins-500 - latin */
@font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* poppins-700 - latin */
@font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* poppins-900 - latin */
@font-face {
    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 900;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
@media screen and (max-width:1000px) {
    .button_manual_right{
        font-size: 15px;
        padding: 10px;
        
    }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,yBAAiB;YAAjB,iBAAiB;AACrB;AACA;;IAEI,8CAA8C;IAC9C,wBAAwB;IACxB,SAAS,EAAE,uEAAuE;AACtF;AACA;IACI,kCAAkC;AACtC;AACA;IACI;QACI,YAAY,EAAE,0CAA0C;IAC5D;IACA;QACI,UAAU,EAAE,iDAAiD;IACjE;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;;IAElB,aAAa;IACb,YAAY;IACZ,eAAe;;IAEf,+BAA+B;IAC/B,qFAAqF;IACrF,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,uBAAuB;IACvB,gCAAgC;IAChC,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,eAAe;IACf,QAAQ;;IAER,SAAS,EAAE,yCAAyC;IACpD,gCAAgC,EAAE,mDAAmD;IACrF,gBAAgB;AACpB;AACA,4BAA4B;AAC5B;IACI,kBAAkB,EAAE,sGAAsG;IAC1H,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,4DAAoE,EAAE,4DAA4D;AACtI;AACA,4BAA4B;AAC5B;IACI,kBAAkB,EAAE,sGAAsG;IAC1H,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,4DAAoE,EAAE,4DAA4D;AACtI;AACA,wBAAwB;AACxB;IACI,kBAAkB,EAAE,sGAAsG;IAC1H,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,4DAAgE,EAAE,4DAA4D;AAClI;AACA,wBAAwB;AACxB;IACI,kBAAkB,EAAE,sGAAsG;IAC1H,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,4DAAgE,EAAE,4DAA4D;AAClI;AACA,8BAA8B;AAC9B;IACI,kBAAkB,EAAE,sGAAsG;IAC1H,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,4DAAsE,EAAE,4DAA4D;AACxI;AACA,wBAAwB;AACxB;IACI,kBAAkB,EAAE,sGAAsG;IAC1H,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,4DAAgE,EAAE,4DAA4D;AAClI;AACA,wBAAwB;AACxB;IACI,kBAAkB,EAAE,sGAAsG;IAC1H,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,4DAAgE,EAAE,4DAA4D;AAClI;AACA,wBAAwB;AACxB;IACI,kBAAkB,EAAE,sGAAsG;IAC1H,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,4DAAgE,EAAE,4DAA4D;AAClI;AACA;IACI;QACI,eAAe;QACf,aAAa;;IAEjB;AACJ","sourcesContent":["body{\n    background-color: #11172e!important;\n    color:#0f1721;\n}\nbody::-webkit-scrollbar{\n    display: none;\n}\n.eye_password{\n    position: absolute;\n    top:11px;\n    right: 6px;\n    color:white;\n    cursor: pointer;\n}\n.step_instruction{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    font-size: 18px;\n    margin-bottom: 10px;\n    color: white;\n    line-height: 1.5;\n    text-align: center;\n}\n.highlight_instruction{\n    color: greenyellow;\n    font-weight: bold;\n}\n.button_manual_right{\n    background-color: #58638980;\n    padding: 5px;\n    border-radius: 5px;\n    cursor: pointer;\n    color:#96a0af;\n    user-select: none;\n}\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    /* display: none; <- Crashes Chrome on hover */\n    -webkit-appearance: none;\n    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */\n}\n.fadeAnimationMain{\n    animation: fadeIn 0.5s ease-in-out;\n}\n@keyframes fadeIn {\n    from {\n        opacity: 0.3; /* Начальная прозрачность: 0 (невидимый) */\n    }\n    to {\n        opacity: 1; /* Конечная прозрачность: 1 (полностью видимый) */\n    }\n}\n.rule {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n\n    padding: 20px;\n    color: white;\n    font-size: 18px;\n    \n    font-family: Popins, sans-serif;\n    background: linear-gradient(315deg, rgb(22 22 22 / 50%) 0%, rgb(43 43 43 / 66%) 100%);\n    border-radius: 10px;\n    border: 1px solid #ffffff1a;\n}\n:where(.css-dev-only-do-not-override-3rel02).ant-card-bordered .ant-card-cover {\n    margin-top: 0!important;\n    margin-inline-start: 0!important;\n    margin-inline-end: 0!important;\n}\nbutton{\n    border: none;\n    cursor: pointer;\n}\n.containerSuccsesMessages{\n    position: fixed;\n    top:90px;\n\n    left: 50%; /* Разместить по горизонтали в середине */\n    transform: translate(-50%, -50%); /* Сдвигаем обратно на половину размеров элемента */\n    z-index: 1000000;\n}\n/* poppins-regular - latin */\n@font-face {\n    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 400;\n    src: url('../fonts/poppins-v20-latin-regular.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* dm-sans-regular - latin */\n@font-face {\n    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n    font-family: 'DM Sans';\n    font-style: normal;\n    font-weight: 400;\n    src: url('../fonts/dm-sans-v11-latin-regular.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* dm-sans-500 - latin */\n@font-face {\n    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n    font-family: 'DM Sans';\n    font-style: normal;\n    font-weight: 500;\n    src: url('../fonts/dm-sans-v11-latin-500.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* dm-sans-700 - latin */\n@font-face {\n    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n    font-family: 'DM Sans';\n    font-style: normal;\n    font-weight: 700;\n    src: url('../fonts/dm-sans-v11-latin-700.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* dm-sans-700italic - latin */\n@font-face {\n    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n    font-family: 'DM Sans';\n    font-style: italic;\n    font-weight: 700;\n    src: url('../fonts/dm-sans-v11-latin-700italic.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* poppins-500 - latin */\n@font-face {\n    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 500;\n    src: url('../fonts/poppins-v20-latin-500.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* poppins-700 - latin */\n@font-face {\n    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 700;\n    src: url('../fonts/poppins-v20-latin-700.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* poppins-900 - latin */\n@font-face {\n    font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 900;\n    src: url('../fonts/poppins-v20-latin-900.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n@media screen and (max-width:1000px) {\n    .button_manual_right{\n        font-size: 15px;\n        padding: 10px;\n        \n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
